import { RevealDemo } from "..\\..\\..\\..\\content\\studio\\fluent-ui\\reveal\\reveal-ui-example.tsx";
import React from 'react';
export default {
  RevealDemo,
  React
};